<template lang="html">
    <section class="aDemo">
        <div class="Vlt-grid">
            <div class="Vlt-col Vlt-col--A-1of3">
                <b>Sentiment Analysis with Conversation (Dial {{ fromNumber }})</b>
                <vue-phone-number-input style="paddingTop:4px" color="#131415" :no-validator-state=true
                    :default-country-code="nexmo.region" v-model="prettyNumber" @update="onUpdate" />
                <vlt-button label="Change Agent Number" secondary app @click="agent" />
                <br />
                <br />
                <chat :nexmo="nexmo" :nodeurl="nodeurl"></chat>
                <reportsAPI :nexmo="nexmo" :reportType="'WEBSOCKET-CALL'" />
            </div>
            <div class="Vlt-col Vlt-col--2of3">
                <line-chart :height="240" :chart-data="datacollection" :options="chartOptions"></line-chart>
            </div>
        </div>

    </section>
</template>

<script lang="js">
import LineChart from './lineChart.js';
import chat from './chat';
import axios from 'axios';
import {
    $BASE,
    $NODEBASE
} from '../../base';
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import reportsAPI from "@/components/reportsAPI";

import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,

} from "@vonagevolta/vue";
import Pusher from "pusher-js";
import {
    $HTTPDEMO,
    requestHandler
} from '../../services/nidsService.js';

export default {
    name: 'aDemo',
    components: {
        LineChart,
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "chat": chat,
        reportsAPI,
    },
    data() {
        return {
            datacollection: {},
            chartOptions: {
                scales: {
                    yAxes: [{
                        ticks: {
                            min: -1.,
                            max: 1.,
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: 12,
                        }
                    }]
                }
            },
            d1: [],
            d2: [],
            t1: [],
            cnt: 0,
            max: 50,
            gotAgent: 0,
            agentLast: 0,
            customerLast: 0,
            cstCnt: 0,
            nodeurl: {},
            fromNumber: '',
            prettyNumber: '',
            numberStuff: {},
            number: '',
            NODEDEMO: {},
            pusher: {},

        }
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        },
        demoItem: {
            type: Object,
            required: false
        }
    },
    mounted() {
        this.fillData();
    },
    beforeDestroy() {
        console.log("beforeDestroy for sentimentDemo")
        if (this.pusher) {
            this.pusher.unsubscribe("sentiment");
        }
    },
    created() {
        var postscript = "/dialogflow";
        if ($NODEBASE.indexOf('ngrok') > 0) {
            postscript = '';
        };
        var url = $NODEBASE + postscript;
        console.log("sentimentDemo url for port " + this.demoItem['port'] + " and base url= " + url);
        if (this.demoItem['port'] > 100) {
            var n = url.indexOf(':', 7);
            url = url.substring(0, n != -1 ? n : url.length) + ":" + this.demoItem['port'];
            console.log("Old URL=" + $NODEBASE + "   New url=" + url);
        }
        this.NODEDEMO = axios.create({
            baseURL: url,
            headers: {
                'Content-Type': 'application/json'
            }
        })

        this.NODEDEMO.interceptors.request.use(
            request => requestHandler(request)
        )
        this.nodeurl = url;

        this.register();
        let pusher = new Pusher(this.nexmo['pusher_key'], { //Pusher Key
            cluster: 'us3',
            forceTLS: true
        });
        this.pusher = pusher;
        this.channel = pusher.subscribe("sentiment");
        this.channel.bind("customer_" + this.nexmo.userid, data => {
            console.log("Got some customer sentiment data: " + JSON.stringify(data));
            this.d1.push(data.customer);
            this.t1.push(new Date().toLocaleTimeString());
            if (!this.gotAgent) {
                this.d2.push(NaN);
            } else {
                this.d2.push(this.agentLast);
            }
            this.cstCnt++;
            if (this.cstCnt > 4) {
                this.agentLast = 0;
            }
            if (this.cnt > this.max) {
                this.d1.shift();
                this.d2.shift();
                this.t1.shift();
            }
            this.customerLast = data.customer;
            this.fillData();
            this.cnt++;
        });
        this.channel.bind("agent_" + this.nexmo.userid, data => {
            console.log("Got some agent sentiment data: " + JSON.stringify(data));
            this.cstCnt = 0;
            this.d2.push(data.agent);
            this.gotAgent = 1;
            this.agentLast = data.agent;
            this.d1.push(this.customerLast);
            this.t1.push(new Date().toLocaleTimeString());
            this.fillData();
        });
        this.channel.bind("reset_" + this.nexmo.userid, data => {
            console.log("Got pusher to Reset charts");
            this.d1 = [];
            this.d2 = [];
            this.t1 = [];
            this.gotAgent = 0;
            this.fillData();
        });
        this.onUpdate({
            isValid: true,
            formatInternational: this.nexmo['phone'],
            formattedNumber: this.nexmo['phone']
        });
        this.fromNumber = parsePhoneNumberFromString("+" + this.nexmo['vfrom']).formatInternational();
        if (this.nexmo['info'] && this.nexmo['info'].phone2) {
            this.prettyNumber = parsePhoneNumberFromString("+" + this.nexmo['info'].phone2).formatNational();

        } else {
            this.prettyNumber = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        }
    },
    methods: {
        fillData() {
            var dset = [{
                label: 'Customer Sentiment',
                borderColor: '#f87979',
                fill: false,
                data: this.d1
            }];
            if (this.gotAgent) {
                dset.push({
                    label: 'Agent Sentiment',
                    borderColor: '#00ff00',
                    fill: false,
                    data: this.d2,
                    spanGaps: true,
                })
            }
            this.datacollection = {
                labels: this.t1,
                datasets: dset
                /*               [{
                                   label: 'Customer',
                                   borderColor: '#f87979',
                                   fill: false,
                                   data: this.d1
                               }, {
                                   label: 'Agent',
                                   borderColor: '#00ff00',
                                   fill: false,
                                   data: this.d2,
                                   spanGaps: true,
                               }]
                               */
            }
        },
        getRandom() {
            return (Math.random() * 2.0) - 1.0; //Math.floor(Math.random() * (10)) + 5
        },
        addData() {
            if (this.cnt > this.max + (this.max / 4)) {
                this.d2.push(this.getRandom());
                this.gotAgent = 1;
            } else {
                this.d2.push(NaN);
            }
            this.d1.push(this.getRandom());
            this.t1.push(new Date().toLocaleTimeString());
            if (this.cnt > this.max) {
                this.d1.shift();
                this.d2.shift();
                this.t1.shift();
            }
            this.fillData();
            //            console.log("Adding data d1=" + this.d1);
            //            console.log("Adding data d2=" + this.d2);
            this.cnt++;
        },
        register() {
            let phone = this.nexmo['phone'];
            if (this.nexmo['info'] && this.nexmo['info'].phone2) {
                phone = this.nexmo['info'].phone2;
            }
            console.log("Registering the Demo Component with the associated backend");
            this.NODEDEMO.post('/register?agent=' + phone, {});
        },
        onUpdate(payload) {
            this.numberStuff = payload;
            this.isValid = payload.isValid;
            if (payload.isValid) {
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                } else {
                    this.isValid = false;
                }
            }
        },
        agent() {
            console.log("Changing the Agent to " + this.number);
            this.NODEDEMO.post('/agent', {
                agent: this.number
            });
            this.$swal({
                //toast: true,
                position: 'left',
                showConfirmButton: false,
                timer: 2000,
                icon: 'success',
                title: 'Agent',
                text: 'Successfully changed!',
            });
        },
    }
}
</script>

<style scoped lang="scss"></style>
